import React from "react";
import { Routes, useLocation, Route } from "react-router-dom";
import { GuestLayout } from "./GuestLayout";
import { PrivateLayout } from "./PrivateLayout";
import { PAGE_URL } from "../utils";
import * as Pages from "../pages";
import { RedirectLayout } from "./RedirectLayout";

export const AppRoutes = () => {
  return (
    <Routes location={location}>
      <Route element={<PrivateLayout />}>
        <Route path={PAGE_URL.DASHBOARD} element={<Pages.Dashboard />} />
        <Route path={`${PAGE_URL.DASHBOARD}${PAGE_URL.CALL_INSIGHTS}/:callId`} element={<Pages.CallsInsights />} />
        <Route path={`${PAGE_URL.CALLS_DATA}`} element={<Pages.CallsData />} />

      </Route>
      <Route element={<GuestLayout />}>
        <Route path={PAGE_URL.LOGIN} element={<Pages.Login />} />
      </Route>
      <Route element={<RedirectLayout />}>
        <Route path={PAGE_URL.REDIRECTION} element={<Pages.Redirect />} />
      </Route>
    </Routes>
  );
};
